<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-slide`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.1973 7.55554H21.3022M2.69922 7.55554H3.41242" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round"/><circle cx="8.169" cy="7.556" stroke="#00BBD8" stroke-width="1.66" r="2.085"/><path d="M20.5801 16.4449H21.2933M2.69922 16.4449H10.8042" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round"/><circle cx="15.831" cy="16.445" stroke="#00BBD8" stroke-width="1.66" r="2.085"/></svg>
</template>
<script>

export default {
  name: 'IconColorSlide',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
